/* import __COLOCATED_TEMPLATE__ from './input-group.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

export default class InputGroup extends Component {
  get isRange() {
    return this.args.isRange;
  }

  get isMultipleInput() {
    return this.args.isMultipleInput;
  }

  get isNumeric() {
    return this.args.isNumeric;
  }

  get options() {
    return this.args.options;
  }

  @action onInputGroupChange(value) {
    if (this.args.onValueChange) this.args.onValueChange(value);
  }
}
